import React from "react";
import AccountingPage from "./AccountingPage";

const AccountingContainer = props => {
  return <AccountingPage {...props} />;
};

export default AccountingContainer;
